import { createSlice, PayloadAction, createAsyncThunk, ThunkAction } from '@reduxjs/toolkit'
import apiGateway from '../../../services/apiGateway'
import { State, ReduxAction } from '../../reducers/reducerType'
import get from 'lodash/get'
import { debug } from '@bt-react/libs/Logger'

// Thunks

export const setAudienceMessage = createAsyncThunk<string, { roomname: string, message: string }>(
  'SET_AUDIENCE_MESSAGE', async ({ roomname, message }) => {

  await apiGateway.sendPresenterToAudienceAnnouncement(roomname, message)
  return message

})
export const clearAudienceMessage = createAsyncThunk<void, string>(
  'CLEAR_AUDIENCE_MESSAGE', async (roomname) => {

  await apiGateway.clearPresenterToAudienceAnnouncement(roomname)

})

// Slice

export interface MessagingSlice {
  isDisabled: boolean
  isUpdating: boolean
  message: string
}

export const messagingDefaultState: MessagingSlice = {
  isDisabled: true,
  isUpdating: false,
  message: ''
}

const messagingSlice = createSlice({
  name: 'messaging',
  initialState: messagingDefaultState,
  reducers: {
    setAnnouncement (state, { payload }: PayloadAction<string>) {

      state.message = payload

    },
    setAnnouncementsState (state, { payload }: PayloadAction<boolean>) {

      state.isDisabled = payload

    }
  },
  extraReducers: {
    [setAudienceMessage.fulfilled.type] (state, { payload }: PayloadAction<string>) {

      state.isUpdating = false
      state.message = payload

    },
    [setAudienceMessage.pending.type] (state) {

      state.isUpdating = true

    },
    [setAudienceMessage.rejected.type] (state) {

      state.isUpdating = false

    },
    [clearAudienceMessage.pending.type] (state) {

      state.isUpdating = true

    },
    [clearAudienceMessage.fulfilled.type] (state) {

      state.isUpdating = false
      state.message = ''

    }
  }
})

export const getAudienceMessage = (roomname: string): ThunkAction<string | Promise<void>, State, void, ReduxAction> => async (dispatch, getState) => {

  let message

  try {

    const result = await apiGateway.getPresenterToAudienceAnnouncement(roomname)
    message = get(result, 'data.message', '')

  }
  catch (e) {

    debug(`Failed to get audience message`)
    return

  }

  if (getState().messaging.message !== message) dispatch(messagingSlice.actions.setAnnouncement(message))

}

export default messagingSlice
